var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql, useQuery } from '@apollo/client';
import TICKET_TYPE_FRAGMENT from 'apollo/fragments/TICKET_TYPE_FRAGMENT';
// TICKET_TYPES
var TICKET_TYPES = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query TicketTypes {\n    ticket_types(filters: { active: true }, per_page: 200) {\n      nodes {\n        ...TICKET_TYPE_FRAGMENT\n        for_bulk_create\n        group {\n          id\n          display_name\n        }\n      }\n    }\n  }\n  ", "\n"], ["\n  query TicketTypes {\n    ticket_types(filters: { active: true }, per_page: 200) {\n      nodes {\n        ...TICKET_TYPE_FRAGMENT\n        for_bulk_create\n        group {\n          id\n          display_name\n        }\n      }\n    }\n  }\n  ", "\n"])), TICKET_TYPE_FRAGMENT);
export var useTicketTypesQuery = function (options) {
    return useQuery(TICKET_TYPES, options);
};
export default TICKET_TYPES;
var templateObject_1;
